(function() {

  'use strict'

  function onFinishRender($timeout) {

    function link(scope, element, attr) {
      if (scope.$last === true) {
        $timeout(function() {
          scope.$emit('ngRepeatFinished');
        });
      }
    }

    var ddo = {};

    ddo.restrict = 'A';
    ddo.link = link;

    return ddo;
  }

  angular
    .module('mandaeApp')
    .directive('onFinishRender', onFinishRender);

}());
